import React from 'react';
import { GroupTab } from './GroupTab';
import { Box, IconButton, Tab, TabList, Tabs } from '@chakra-ui/react';
import { AddIcon } from '@chakra-ui/icons';

const maxGroups = 5;

export function GroupTabs({ groups, addGroup, onRemoveGroup, tabIndex, setTabIndex, saveGroup }) {
    const canAddGroup = groups.length < maxGroups;

    return (
        <Box alignSelf="center" display="flex" alignItems="flex-end">
            <Tabs index={tabIndex} onChange={setTabIndex} variant="internal" size="sm">
                <TabList>
                    {groups.map((group, groupIndex) => (
                        <Tab as="div" key={group.groupId}>
                            <GroupTab
                                group={group}
                                onRemoveGroup={() => onRemoveGroup(group.groupId, groupIndex)}
                                isTabActive={tabIndex === groupIndex}
                                canDelete={groups.length > 1}
                                saveGroup={saveGroup}
                            />
                        </Tab>
                    ))}
                </TabList>
            </Tabs>
            {canAddGroup && (
                <IconButton
                    aria-label="Add group"
                    icon={<AddIcon />}
                    variant="ghost"
                    onClick={addGroup}
                    size="sm"
                    data-testid="add-group-button"
                />
            )}
        </Box>
    );
}
